import React, { useState } from 'react'
import { Typography, Container, Box, Button, TextField } from '@mui/material'
import { useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import SubSettingsArea from 'components/SubSettingsArea'
import VisibilityIcon from '@mui/icons-material/Visibility'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff'
import { useAtom } from 'jotai'
import { pictogramsFamilyAtom } from 'atoms'
import { useTheme } from '@mui/material/styles'

import PictogramCard from 'components/PictogramsViewer/PictogramCard'
import ImageSelector from 'components/ImageSelector'

function Pictogram() {
  const { t } = useTranslation()
  const theme = useTheme()
  const { uuid } = useParams()
  const [pictogram, setPictogram] = useAtom(pictogramsFamilyAtom(uuid))
  const { imageAsText, caption } = pictogram
  const [newCaption, setNewCaption] = useState(caption || '')
  const handleVisibility = () => {
    setPictogram((prevPictogram) => ({
      ...prevPictogram, // Mantenemos las demás propiedades intactas
      imageAsText: !prevPictogram.imageAsText,
    }))
  }

  // Handle real-time caption change (for updating the input field)
  const handleCaptionChange = (event) => {
    setNewCaption(event.target.value)
  }

  // Save the caption when the user clicks the Save button
  const handleCaptionSave = () => {
    setPictogram((prevPictogram) => ({
      ...prevPictogram,
      caption: newCaption, // Save the new caption
    }))
  }

  return (
    <Container maxWidth="lg">
      <Box my={4}>
        <Typography
          sx={{ mt: 4, color: theme.palette.primary.main }}
          variant="h1"
        >
          {t('pictogramEditor')}
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: 'row',
          alignItems: 'flex-start', // Adjust alignment as needed
          gap: 2, // Optional: Adds spacing between child elements
        }}
      >
        <PictogramCard uuid={uuid} showActions={false} />

        <SubSettingsArea text={t('imageSettings')} sx={{ pt: 0, mb: 2 }}>
          <ImageSelector imageKey={uuid} />
          <Button
            onClick={handleVisibility}
            variant="contained"
            color="secondary"
            style={{ minWidth: '180px' }}
            component="span"
            startIcon={imageAsText ? <VisibilityIcon /> : <VisibilityOffIcon />}
          >
            {imageAsText ? t('showImage') : t('hideImage')}
          </Button>
        </SubSettingsArea>

        <SubSettingsArea text={t('captionSettings')} sx={{ pt: 0, mb: 2 }}>
          <TextField
            label={t('modifyText')}
            value={newCaption}
            onChange={handleCaptionChange} // <-- Still use this for real-time changes
            fullWidth
            variant="outlined"
            sx={{ mb: 2 }}
          />
          <Button
            onClick={handleCaptionSave} // <-- Save the caption when the user clicks this button
            variant="contained"
            color="primary"
            disaled={newCaption === caption} // <-- Disable the button if the caption hasn't changed
          >
            {t('save')}
          </Button>
        </SubSettingsArea>
      </Box>
    </Container>
  )
}

export default Pictogram
